<template>
  <div>
    <ve-ring :data="sourceData" height="230px" :settings="circleChartSettings"></ve-ring>
  </div>
</template>
<script>
/*eslint-disable*/
export default {
  name: "cicleChartTwo",
  data() {
    //圆形设置
    this.circleChartSettings = {
      radius: ["40","60"],
      offsetY: 120,
      legend: {
        // x 设置水平安放位置，默认全图居中，可选值：'center' ¦ 'left' ¦ 'right' ¦ {number}（x坐标，单位px）
        x: "center",
        // y 设置垂直安放位置，默认全图顶端，可选值：'top' ¦ 'bottom' ¦ 'center' ¦ {number}（y坐标，单位px）
        y: "left",
        itemWidth: 24, // 设置图例图形的宽
        itemHeight: 18, // 设置图例图形的高
        textStyle: {
          color: "#666" // 图例文字颜色
        }
      }
    };
    return {
      sourceData:{
        columns: ['type', 'numbers'],
        rows: []
      },
    };
  },
  props: {
    sourceList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  model: {
    prop: "sourceList"
  },
  mounted() {
    this.$nextTick(() => {
      if (this.sourceList) {
        this.initPage();
      }
    });
  },
  methods: {
    initPage() {
      let _this = this;
      _this.sourceData.rows = _this.sourceList
    }
  },
  watch: {
    sourceList: function() {
      this.initPage();
    }
  }
};
</script>
<style lang="less">
</style>